var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8444_25617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.7559V22.848",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.3779V12.3251",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 27.9436C21.7501 27.9436 26.9287 25.3751 26.9287 19.6579C26.9287 13.4436 23.8215 9.30078 17.6072 6.19363L20.0515 3.04506C20.1757 2.83848 20.2431 2.60274 20.2468 2.36174C20.2505 2.12073 20.1904 1.88304 20.0726 1.67273C19.9549 1.46243 19.7836 1.28701 19.5762 1.16423C19.3687 1.04146 19.1326 0.975704 18.8915 0.973633H10.1087C9.86765 0.975704 9.63146 1.04146 9.42404 1.16423C9.21663 1.28701 9.04535 1.46243 8.92758 1.67273C8.80981 1.88304 8.74974 2.12073 8.75344 2.36174C8.75715 2.60274 8.8245 2.83848 8.94868 3.04506L11.393 6.21435C5.17868 9.3422 2.07153 13.4851 2.07153 19.6993C2.07153 25.3751 7.2501 27.9436 14.5001 27.9436Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4287 19.8029C12.6815 20.103 12.9996 20.3411 13.3587 20.4991C13.7177 20.6571 14.1082 20.7307 14.5002 20.7144C15.0992 20.7552 15.6908 20.5622 16.1505 20.1759C16.6102 19.7896 16.9022 19.2401 16.9652 18.6429C16.9022 18.0458 16.6102 17.4963 16.1505 17.11C15.6908 16.7237 15.0992 16.5307 14.5002 16.5715C13.9011 16.6123 13.3095 16.4193 12.8498 16.033C12.3901 15.6467 12.0981 15.0972 12.0352 14.5001C12.093 13.9008 12.3837 13.3482 12.8446 12.9609C13.3055 12.5736 13.8999 12.3825 14.5002 12.4287C14.8852 12.4051 15.2707 12.4672 15.6289 12.6105C15.987 12.7537 16.309 12.9746 16.5716 13.2572",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8444_25617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/moneyBag.bf478047ab8310db03c4db70f5927302.svg";
export { ForwardRef as ReactComponent };